import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/default.jpg'


const _withScopeId = n => (_pushScopeId("data-v-1ce8705e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "profile" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "details" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "heading" }
const _hoisted_8 = { class: "stats fontClass" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center mx-20" }, "Allergies", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-headers" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date diagnosed")
  ])
], -1))
const _hoisted_15 = {
  key: 1,
  class: "center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_PhoneOutlined = _resolveComponent("PhoneOutlined")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    (_ctx.patient.firstName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("header", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.patient.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.patient.image,
                      alt: _ctx.patient.firstName,
                      class: "profile-pic"
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_0,
                      alt: _ctx.patient.firstName,
                      class: "profile-pic"
                    }, null, 8, _hoisted_6)),
                _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.patient.firstName) + " " + _toDisplayString(_ctx.patient.lastName), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_MailOutlined, { class: "iconStyle" }),
                    _createElementVNode("h4", null, _toDisplayString(_ctx.patient.email), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_HomeOutlined, { class: "iconStyle" }),
                    _createElementVNode("h4", null, _toDisplayString(_ctx.patient.address), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_PhoneOutlined, { class: "iconStyle" }),
                    _createElementVNode("h4", null, _toDisplayString(_ctx.patient.contact), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_12,
            (_ctx.patient.allergies && _ctx.patient.allergies.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                  _hoisted_14,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patient.allergies, (allergy) => {
                    return (_openBlock(), _createElementBlock("tbody", {
                      key: allergy,
                      class: "center"
                    }, [
                      _createElementVNode("td", null, _toDisplayString(allergy), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.parseDate(_ctx.patient.createdAt)), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, "There are no allergies for this patient as of now."))
          ])
        ]))
      : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
  ], 64))
}